import { TextField, Autocomplete } from "@mui/material";
import { useState, useEffect, type SyntheticEvent } from "react";
import { useLocation } from "react-router-dom";
import { getDivisionCodePrefs } from "../api/division-code-prefs";
import type { PrefItem } from "../types/division-code";

type PrefectureSelectProps = {
  branchId?: number | null;
  customerId?: number | null;
  changedValue: (prefCodes: string[]) => void;
  isMultiple?: boolean;
  isDisasterId?: boolean;
};

const PrefectureSelect = ({
  branchId,
  customerId,
  changedValue,
  isMultiple = true,
  isDisasterId = true,
}: PrefectureSelectProps) => {
  const searchParams = new URLSearchParams(useLocation().search);
  const disasterId = isDisasterId ? searchParams.get("disaster-id") : null;
  const [prefs, setPrefs] = useState<PrefItem[]>([]);

  const getPref = async () => {
    try {
      const response = await getDivisionCodePrefs({
        disaster_id: disasterId,
        m_branch_id: branchId,
        m_customer_id: customerId,
        order: null,
        sort: null,
        page: 1,
      });
      if (response.status === "ok") {
        const data = response.prefs;
        setPrefs(Array.isArray(data) ? data : []);
      }
    } catch (error) {
      console.error("API呼び出しエラー", error);
    }
  };

  useEffect(() => {
    getPref();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [disasterId, branchId, customerId]);

  const handleChange = (
    _event: SyntheticEvent,
    newValues: PrefItem | PrefItem[] | null
  ) => {
    console.log("Selected value:", newValues);

    const valuesArray = Array.isArray(newValues)
      ? newValues
      : newValues
        ? [newValues]
        : [];

    if (valuesArray.length === 0) {
      changedValue([]);
      return;
    }

    const prefValuesArray = valuesArray
      .filter((value) => value && value.pref_code)
      .map((newValue) => newValue.pref_code);

    changedValue(prefValuesArray);
  };

  return (
    <Autocomplete
      multiple={isMultiple}
      limitTags={2}
      fullWidth
      size="small"
      options={prefs}
      getOptionLabel={(pref) => pref.pref_name}
      isOptionEqualToValue={(option, value) =>
        option.pref_code === value.pref_code
      }
      renderInput={(params) => (
        <TextField
          {...params}
          name="prefectureSelect"
          placeholder={isMultiple ? "複数選択可" : "選択可"}
        />
      )}
      onChange={handleChange}
    />
  );
};

export default PrefectureSelect;
